import { http } from "./index";
import axios from "axios";

class DestinationsService {
  static requestHotelsAndFilters = (isRoseGold, offerId) => {
    var rose_gold_param = isRoseGold === 'true' ? "&rose_gold=true" : "";
    var offer_id_param = offerId !== "" ? "&offer_id="+ offerId : ""
    var locale = $('html').attr('lang');
    var url = '/api/v1/destinations_hotels?format=js' + rose_gold_param + offer_id_param;
    var url_locale = locale == 'en' ? "/" + locale + url : url;

    // This has to change, We can't use Environment variables as Staging isn't a valid ENVIRONMENT for NODE.
    return http.get(`${window.location.origin}` + url_locale);
  };
}

export { DestinationsService };
